import Vue from 'vue';
import axios from "axios";
import Papa from "papaparse";

Vue.use(axios);

// CSV読み込み


//読み込んだCSVデータの反映
// function changeData(after) {

//     // this.update_message = "";


// }

async function readFileAsync(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      // ファイル読み込み成功時
      reader.onload = () => resolve(reader.result);
  
      // エラー時
      reader.onerror = () => reject(reader.error);
  
      // ファイルをテキストとして読み込み
      reader.readAsText(file);
    });
  }


export default async function  mapCsvRead(e)  {

    let file = e.target.files[0];
    if (file.name && file.name.indexOf(".csv") <= -1) {
      return;
    }

    let output = [];

    // let reader = new FileReader();
    const fileContent = await readFileAsync(file);

    const parsed = Papa.parse(fileContent, { header: true , worker: false });
    output = parsed.data;


    // reader.onload = () => {
    //     const parsed = Papa.parse(reader.result, { header: true , worker: false });


    //     for (let key in parsed.data) {
    //         const data = parsed.data[key];
    //         // const target_img_no = data.img_no;
    //         // const target_id = data.id;
    //         if(data.map_id != ""){
    //             output.push(data)
    //         }
    //     }
    //     // console.log("csvの中身2＝",parsed.data)
    // };

    return output;

}
